export enum Roles {
  ADMIN = 'admin',
  CLIENT = 'client',
  USER = 'user',
  MANAGER = 'manager',
  BOSS = 'boss'
}

export class AuthHelper {
  public static IsBoss(roles: string[] | undefined): boolean {
    return !!roles?.some((role) => role == Roles.BOSS);
  }

  public static IsAdmin(roles: string[] | undefined): boolean {
    return !!roles?.some((role) => role == Roles.ADMIN);
  }

  public static IsClient(roles: string[] | undefined): boolean {
    return !!roles?.some((role) => role == Roles.CLIENT);
  }

  public static IsManager(roles: string[] | undefined): boolean {
    return !!roles?.some((role) => role == Roles.MANAGER);
  }

  public static IsUser(roles: string[] | undefined): boolean {
    return !!roles?.some((role) => role == Roles.USER);
  }

  /** Директор / администратор (бэкенд: BOSSES). */
  public static IsBosses(roles: string[] | undefined): boolean {
    return AuthHelper.IsBoss(roles) || AuthHelper.IsAdmin(roles);
  }

  /** Руководитель / директор / администратор. */
  public static IsManagers(roles: string[] | undefined): boolean {
    return AuthHelper.IsManager(roles) || AuthHelper.IsBoss(roles) || AuthHelper.IsAdmin(roles);
  }
}
